import httpClient from '@/http-client'

export const get = (Options = {}) => {
	return httpClient
		.get('/api/quotations', Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const store = data => {
	return httpClient
		.post('/api/quotations', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const find = (id, Options = {}) => {
	return httpClient
		.get(`/api/quotations/${id}`, Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
	return httpClient
		.delete(`/api/quotations/${id}`)
		.then(response => Promise.resolve(response.data))
}

export const printPDF = (id, Options = {}) => {
	return httpClient
		.get(`/api/quotations/preview-pdf/${id}`)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
	return httpClient
		.get('/api/quotations/form-view-models', Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export default {
	get,
	store,
	find,
	destroy,
	formViewModel,
	printPDF
}
